export { SplitFactory } from './factory';
